import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function VideoFeature() {
  return (
    <section
      id="in-action"
      className="py-24 lg:py-40 bg-white border-y border-[#1E1E1E]/10"
      data-testid="video-feature-section"
    >
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Portrait video — desktop/tablet as intentional portrait; mobile as full width */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-15% 0px" }}
            transition={{ duration: 0.9, ease: [0.2, 0.7, 0.2, 1] }}
            className="lg:col-span-5"
          >
            <div
              className="mx-auto w-full max-w-[380px] lg:max-w-none border border-[#1E1E1E]/10 overflow-hidden bg-[#F5F4EF]"
              style={{ aspectRatio: "9 / 16" }}
            >
              <video
                data-testid="plst-video"
                src="/media/plst-training-video.mp4"
                poster="/media/plst-training-video-poster.jpg"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                className="w-full h-full object-cover"
                aria-label="Physio-Led Strength Training in action"
              />
            </div>
          </motion.div>

          {/* Editorial copy */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-15% 0px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <div className="text-xs uppercase tracking-[0.28em] text-[#8A8A8A]">
              <span className="w-8 h-px bg-[#A67C00] inline-block align-middle mr-3" />
              PLST in action
            </div>
            <h2 className="mt-6 italic font-medium text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-[#1E1E1E]">
              This is what <br />
              <span className="text-[#A67C00]">Physio-Led looks like.</span>
            </h2>
            <p className="mt-6 text-[#1E1E1E]/75 text-base md:text-lg leading-relaxed max-w-xl">
              Different people. Different goals. Individual programs. Always led by a physiotherapist.
            </p>
            <Link
              to="/book"
              data-testid="video-book-cta"
              className="group inline-flex items-center gap-3 mt-10 bg-[#1E1E1E] text-[#F5F4EF] px-7 py-4 text-sm font-medium hover:bg-[#A67C00] transition-colors duration-500"
            >
              Book an Assessment
              <span className="transition-transform group-hover:translate-x-1">→</span>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
